import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { SignUpAskPhone } from './ask-phone/SignUpAskPhone';
import { SignUpConfirmPhone } from './confirm-phone/SignUpConfirmPhone';
import { SignUpMailConfirmation } from './mail/SignUpMailConfirmation';
import { SignUpUser } from './user/SignUpUser';
import { SignUpUserCaptcha } from './user/SignUpUserCaptcha';
import { SignUpUserCaptchaFromLawyer } from './user/SignUpUserCaptchaFromLawyer';

export function SignUpRouter() {
  return (
    <Switch>
      <Route exact path="/inscription" component={SignUpUser} />
      <Route
        exact
        path="/inscription/authentification"
        render={props => <SignUpAskPhone {...props} />}
      />
      <Route
        exact
        path="/inscription/verification"
        render={props => <SignUpConfirmPhone {...props} />}
      />
      <Route
        exact
        path="/inscription/mail"
        render={() => <SignUpMailConfirmation />}
      />
      <Route path="/inscription/:id" component={SignUpUser} />
      {/* pages where a signup captcha can be displayed: decision page, lawyer page and decision directory */}
      <Route path="/d/:id" component={SignUpUserCaptcha} />
      <Route path="/p/:id" component={SignUpUserCaptchaFromLawyer} />
      <Route path="/repertoire/decision" component={SignUpUserCaptcha} />
    </Switch>
  );
}
